/**
 * @author NikolaV
 */

import * as React from 'react';
import { Notify } from '@shared/ui-native/Notify';
import { DateTimeSpan } from '@shared/ui-react/UtilComponents';
import { FilesService } from '@shared/services/FilesService';
import './FileComments.scss';


export interface IFileComment {
    timestamp: number;
    text: string;
    user: {
        username: string;
    };
    server: boolean;
    isNew?: boolean;
}

export class FileComments extends React.Component<{
    fileId: number,
    readOnly: boolean
}, {}> {
    state = {
        nextPage: 1,
        comments: [],
        isLoading: false,
    };

    input: HTMLTextAreaElement;

    fetch = _.debounce(() => {
        this.setState({ isLoading: true });

        if (this.request) {
            this.request.abort();
        }
        this.request = FilesService.getComments(this.props.fileId, this.state.nextPage, this.state.nextPage > 1);

        this.request.done(resp => {
            const newComments = resp.comments;
            newComments.sort((c1, c2) => c2.timestamp - c1.timestamp);

            this.setState({
                nextPage: resp.paging ? resp.paging.next : 3,
                comments: newComments,
                isLoading: false,
            });

            this.request = null;
        });

    }, 100);

    private request;

    componentDidUpdate(prevProps) {
        if (this.props.fileId !== prevProps.fileId) {
            this.setState({ nextPage: null });

            if (this.props.fileId > 0) {
                this.setState({ isLoading: true });
                this.fetch();
            }
        }
    }

    componentDidMount() {
        if (this.props.fileId > 0) {
            this.setState({ isLoading: true });
            this.fetch();
        }
    }

    public render() {
        const { isLoading, nextPage } = this.state;

        let commentEls = [];
        if (this.state.comments.length === 0 && !isLoading) {
            commentEls.push(<div key='no_comments' id='no_comments_msg'
                                 className='text-center'>{kuura.getMessage('js_files.no_comments_for_file')}</div>);
        }
        else {
            commentEls = this.state.comments.map((comment, i) =>
                <FileComment comment={comment} key={i}/>,
            );
        }

        return (
            <div id='item-comments-wrapper' className={isLoading ? 'overlay-loading' : null}>
                <ul id='item-comments-list' className='explorer-list filefolder-icons'>
                    {commentEls}
                </ul>

                { (nextPage && nextPage <= 2) && <button className='block file-load-more-comment' onClick={this.fetch}
                                      disabled={isLoading}>{kuura.getMessage('js_files.load_older_comments')}</button>}

                { !this.props.readOnly && <form onSubmit={this.handleSubmit.bind(this)} id='comment-add'>
                    <textarea ref={e => this.input = e} disabled={isLoading} required={true}></textarea>
                    <button id='comment-add-btn' disabled={isLoading}>{kuura.getMessage('js_files.add_comment_btn')}</button>
                </form>
                }
            </div>
        );
    }

    addComment(comment: IFileComment) {
        comment.isNew = true;

        const comments = this.state.comments.map(c => {
            c.isNew = false;
            return c;
        });
        comments.unshift(comment);

        this.setState({
            comments,
            isLoading: false,
        });
    }

    handleSubmit(e) {
        e.preventDefault();
        const val = $.trim(this.input.value);
        this.input.value = '';
        this.setState({ isLoading: true });

        FilesService.addComment(this.props.fileId, val)
             .done(resp => this.addComment(resp.comment))
             .fail(Notify.error);
    }
}

class FileComment extends React.Component<{ comment: IFileComment }, {}> {
    public render() {
        const { user, timestamp, isNew, server } = this.props.comment;
        let author = user ? user.username : '';
        const text = this.props.comment.text;

        let msgParts = ['', ''];
        if (server) {
            msgParts = kuura.getMessage('js_files.model_comment.auto_msg', text, user.username).split(',');
            author = 'server';
        }

        const classes = ['comment-wrapper'];
        if (isNew) classes.unshift('new');

        return (
            <div className={classes.join(' ')}>
                <div className='comment-info'>{author} <DateTimeSpan timestamp={timestamp}/></div>
                {server ?
                    <div className='comment-msg'>{msgParts[0]}<br/>{msgParts[1]}</div> :
                    <div className='comment-msg'>{text}</div>
                }
            </div>
        );
    }
}
